import {appApi} from "./api.service";
import moment from "moment";
import {CalendarEvent} from "@models/calendar";

let endpointPrefix = 'worker';

const getActivities = async () => {
    return appApi.get(endpointPrefix + '/activities?withoutPastActivities=1');
}

const getActivitiesByDate = async (startDate: Date, endDate: Date): Promise<CalendarEvent[]> => {
	const start: string = moment(startDate, 'YYYY-MM-DD').format('DD-MM-YYYY');
	const end: string = moment(endDate, 'YYYY-MM-DD').format('DD-MM-YYYY');

	const response = await appApi.get(endpointPrefix + '/activities?startDate=' + start + '&endDate=' + end);

	return response.data;
}

const confirmProposal = async (id: number) => {
	return appApi.post(endpointPrefix + '/proposals/' + id + '/confirm');
}

const rejectProposal = async (id: number) => {
	return appApi.post(endpointPrefix + '/proposals/' + id + '/reject');
}

const approveTask = async (id: number) => {
	return appApi.post(endpointPrefix + '/proposals/' + id + '/accept');
}

const rejectTask = async (id: number) => {
	return appApi.post(endpointPrefix + '/proposals/' + id + '/reject');
}

export {
	getActivities,
	getActivitiesByDate,
	approveTask,
	rejectTask,
	confirmProposal,
	rejectProposal,
};
